module.exports = __webpack_public_path__ + "img/c5.eedee7e9.jpg";